import React from 'react';
export const FocusTrapContext = React.createContext({
    register: () => { },
    unregister: () => { },
});
//# sourceMappingURL=FocusTrapContext.js.map